/**
 * Máscaras para telefone (fixo 10 dígitos e celular 11 dígitos).
 */

import { TELEFONE_MAX } from "../../domain/validators/terceiros.constantes.js";
import { sanitizarTelefone } from "../../domain/rules/normalizadores.js";

export { sanitizarTelefone };

/**
 * Sanitiza telefone: só dígitos.
 * Remove caracteres de formatação antes de salvar.
 * @param {*} valor
 * @returns {string}
 */
/**
 * Sanitiza telefone para máscara (bloqueia além do limite).
 * @param {*} valor
 * @returns {string}
 */
export function sanitizarTelefoneParaMascara(valor) {
  return sanitizarTelefone(valor).slice(0, TELEFONE_MAX);
}

/**
 * Aplica máscara incremental: (00) 0000-0000 (10) ou (00) 00000-0000 (11).
 * @param {*} valor
 * @returns {string}
 */
export function aplicarMascaraTelefone(valor) {
  const raw = sanitizarTelefoneParaMascara(valor);
  if (!raw) return "";
  if (raw.length <= 2) return `(${raw}`;
  if (raw.length <= 6) return `(${raw.slice(0, 2)}) ${raw.slice(2)}`;
  if (raw.length <= 10) {
    // Fixo: (00) 0000-0000
    return `(${raw.slice(0, 2)}) ${raw.slice(2, 6)}-${raw.slice(6)}`;
  }
  // Celular: (00) 00000-0000 – bloqueia além de 11 dígitos
  return `(${raw.slice(0, 2)}) ${raw.slice(2, 7)}-${raw.slice(7, 11)}`;
}

/**
 * Remove máscara.
 * @param {*} valor
 * @returns {string}
 */
export function removerMascaraTelefone(valor) {
  return sanitizarTelefone(valor);
}
